// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog--save-dashboard .input-field{border:1px solid #aeb2b7;padding:10px 5px;width:450px;max-width:100%}.dialog--save-dashboard .action{margin-left:7px}", ""]);
// Exports
module.exports = exports;
